import React, { useRef } from "react";

const AuraIlluminatedShadesPage = () => {

  const whatWeOfferRef = useRef(null); // Reference for the "What We Offer" section

  const scrollToSection = () => {
    if (whatWeOfferRef.current) {
      whatWeOfferRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };
  const images = [
    "images/aura.jpg",
    "images/aura1.webp",
    "images/landing2.png",
    "images/aura3.webp",
    "images/roombright.png",
    "images/bright.jpg",

  ];

  return (
    <div className="bg-gray-50 text-gray-900">
      {/* Hero Section */}
      <section 
  className="text-center object-cover min-h-screen flex flex-col pt-60 md:pt-40 lg:text-left"
  style={{ backgroundImage: "url('images/illuminated.jpg')" }}
>
  <div className="px-8 sm:px-16 lg:px-24">
    <h1 className="text-4xl md:text-6xl  2xl:text-[120px] font-semibold text-[#ffff] font-Montserrat uppercase  mb-4 md:mb-1  lg:text-7xl lg:text-left">
      Aura 
    </h1>

    <h1 className="text-4xl md:text-6xl 2xl:text-[120px] font-semibold text-[#ffff] font-Montserrat uppercase  mb-4 md:mb-1  lg:text-7xl lg:text-left">
      Illuminated 
    </h1>
    <h1 className="text-4xl md:text-6xl 2xl:text-[120px] font-semibold text-[#ffff] font-Montserrat uppercase  mb-4 md:mb-1  lg:text-7xl lg:text-left">
      Shades
    </h1>
  </div>

  {/* Button positioned below the text */}
  <div className="mt-4 lg:mt-5 flex justify-center lg:pl-24 2xl:pl-60 lg:justify-start">
    <button onClick={scrollToSection} className="text-black bg-[#fff] text-sm 2xl:text-xl xl:w-40 2xl:w-52 px-6 py-2">
      LEARN MORE
    </button>
  </div>
</section>



 {/* Content Explanation Section */}
 <section className="py-16 font-playfair pt-20 bg-gray-100">
        <div className="container mx-auto px-6">
          <h2 ref={whatWeOfferRef} className="text-3xl md:text-7xl font-bold text-center mb-8">What We Offer</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <div className="text-center">
              <h3 className="text-2xl md:text-6xl font-semibold mb-4">
                Illuminated Shades
              </h3>
              <p className="text-lg md:text-3xl leading-7 ">
                Discover a wide range of shades that change the ambiance of your
                space with a touch of light. Our collection brings innovation
                and elegance together for a captivating experience.
              </p>
            </div>
            <div className="text-center">
              <h3 className="text-2xl md:text-6xl font-semibold mb-4">Quality That Lasts</h3>
              <p className="text-lg md:text-3xl leading-7">
                Our shades are crafted with the highest quality materials,
                ensuring durability and a timeless aesthetic. Elevate your
                surroundings with products designed to impress.
              </p>
            </div>
          </div>
        </div>
      </section>
      {/* Gallery Section */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-6">
          <h2 className="text-3xl font-bold md:text-6xl font-playfair text-center mb-8">Gallery</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
            {images.map((image, index) => (
              <div
                key={index}
                className="group relative rounded-lg overflow-hidden shadow-lg transform transition-all duration-300 hover:scale-105"
              >
                <img
                  src={image}
                  alt={`Gallery Image ${index + 1}`}
                  className="w-full h-64 object-cover"
                />
                <div className="absolute inset-0 bg-black bg-opacity-50 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center">
                  <p className="text-white font-semibold text-lg">
                    Image {index + 1}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

     

      {/* FAQ Section */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-6">
          <h2 className="text-3xl md:text-5xl font-bold text-center mb-8">FAQs</h2>
          <div className="space-y-6">
            {[
              {
                question: "What are Aura Illuminated Shades?",
                answer:
                  "Aura Illuminated Shades are high-quality, innovative shades designed to create a captivating ambiance with the perfect blend of light and color.",
              },
              {
                question: "How durable are the shades?",
                answer:
                  "Our shades are made from premium materials, ensuring they are long-lasting and durable for years of use.",
              },
              {
                question: "Do the shades come in different sizes?",
                answer:
                  "Yes, Aura Illuminated Shades are available in a variety of sizes to suit different spaces and needs.",
              },
            ].map((faq, index) => (
              <div key={index} className="p-6 border rounded-lg shadow-md">
                <h3 className="text-xl md:text-3xl font-semibold mb-2">{faq.question}</h3>
                <p className="text-lg md:text-lg">{faq.answer}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

    
    </div>
  );
};

export default AuraIlluminatedShadesPage;
